export default abstract class RESTService {
	public static async get(url: string): Promise<any> {
		try {
			const response = await fetch(url, {
				method: "GET",
				headers: {
					accept: "application/json",
				},
			});
			if (response.ok) {
				return (await response.json()).data;
			}
		} catch {}
	}

	public static async post(url: string, body: any): Promise<any> {
		try {
			const response = await fetch(url, {
				method: "POST",
				headers: {
					accept: "application/json",
				},
				body: body,
			});
			if (response.ok) {
				return (await response.json()).data;
			}
		} catch {}
	}

	public static async getDummy(dummy: { data: any }): Promise<any> {
		return (await Promise.resolve(dummy)).data;
	}
}
